"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var account;
        (function (account) {
            var logOn;
            (function (logOn) {
                class InitArgs {
                    constructor() {
                        this.isLockedOut = false;
                        this.lockedOutMinutesLeft = 0;
                        this.logOnLocation = '';
                        this.logOnStep = '';
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    if (_initArgs.isLockedOut)
                        startTimer(_initArgs.lockedOutMinutesLeft, $('#time'));
                    checkVersion();
                    if (!$('#ReturnUrl').attr('value')) {
                        const returnurl = getUrlParamByName('ReturnUrl');
                        $('#ReturnUrl').attr('value', returnurl ? returnurl : '');
                    }
                    appn.localStorage.removeItem('helpWidgetDisabled');
                    if (_initArgs.logOnStep === 'TypeSelect')
                        $('.btn-signin').click(function (e) {
                            e.preventDefault();
                            const form = $('form');
                            const loginType = $(this).data('logintype');
                            form.append(`<input type="hidden" name="loginType" value="${loginType}" />`);
                            form.submit();
                        });
                    initTwoFactorAuth();
                    $('select').select2({
                        theme: 'bootstrap4',
                        width: '100%'
                    });
                }
                logOn.init = init;
                function startTimer(duration, display) {
                    let timer = duration, minutes, seconds;
                    setInterval(function () {
                        const minStr = timer / 60;
                        const secStr = timer % 60;
                        minutes = parseInt(minStr, 10);
                        seconds = parseInt(secStr, 10);
                        minutes = minutes < 10 ? '0' + minutes : minutes;
                        seconds = seconds < 10 ? '0' + seconds : seconds;
                        display.text(minutes + ':' + seconds);
                        if (--timer < 0)
                            window.location.href = _initArgs.logOnLocation;
                    }, 1000);
                }
                function getInternetExplorerVersion() {
                    let rv = -1;
                    if (navigator.appName === 'Microsoft Internet Explorer') {
                        const ua = navigator.userAgent;
                        const re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
                        if (re.exec(ua))
                            rv = parseFloat(RegExp.$1);
                    }
                    return rv;
                }
                function getUrlParamByName(name, url) {
                    if (!url)
                        url = window.location.href;
                    name = name.replace(/[\[\]]/g, '\\$&');
                    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
                    if (!results)
                        return null;
                    if (!results[2])
                        return '';
                    return decodeURIComponent(results[2].replace(/\+/g, ' '));
                }
                function checkVersion() {
                    const ver = getInternetExplorerVersion();
                    if (ver > -1)
                        if (ver < 10.0) {
                            $('.btn').remove();
                            window.alert(T('You are using an unsupported version of Internet Explorer. Please upgrade to a modern browser such as Internet Explorer 10, Edge, FireFox, Chrome or Safari.'));
                        }
                }
                function initTwoFactorAuth() {
                    if (_initArgs.logOnStep !== 'TwoFactorAuth')
                        return;
                    $('.btn-signin-twoFactorAuth').click(function (e) {
                        e.preventDefault();
                        let verifyString = '';
                        $('.two-factor-auth-verify-code-input').each(function (index, numberElement) {
                            verifyString += $(this).val();
                        });
                        if (verifyString.length !== 6) {
                            clearVerifyInputs();
                            return;
                        }
                        $('#TwoFactorAuthVerifyCode').val(verifyString);
                        $('.form-signin').submit();
                    });
                    $('.two-factor-auth-verify-code-input').off().on('input', function () {
                        const currentVal = $(this).val().trim();
                        const id = $(this).prop('id');
                        if (!currentVal)
                            return;
                        if (currentVal.length > 1) {
                            if (id.endsWith('t6')) {
                                $(this).val(currentVal.slice(0, -1));
                                return;
                            }
                            const firstSixChars = currentVal.substring(0, 6);
                            const bits = firstSixChars.split('');
                            $('#twoFactorAuthVerifyCodeInput2').val(bits[1]);
                            $('#twoFactorAuthVerifyCodeInput3').val(bits[2]);
                            $('#twoFactorAuthVerifyCodeInput4').val(bits[3]);
                            $('#twoFactorAuthVerifyCodeInput5').val(bits[4]);
                            $('#twoFactorAuthVerifyCodeInput6').val(bits[5]);
                            $('#twoFactorAuthVerifyCodeInput1').val(bits[0]).focus().select();
                            return;
                        }
                        if (currentVal.length === 1) {
                            if (!id.endsWith('t6'))
                                $(this).next().val('').focus();
                            return;
                        }
                        $(this).val(currentVal.slice(0, -1));
                    });
                    $('.btn-twoFactorAuthClearVerify').off().on('click', function (e) {
                        e.preventDefault();
                        clearVerifyInputs();
                    });
                    $('.btn-whySeeTwoFa').off().on('click', function (e) {
                        e.preventDefault();
                        const msg = T('Why am I seeing this?\n') +
                            T('Your administrator has turned on two-factor authentication for your organization to provide increased security.\n\n') +
                            T('What is two-factor authentication?\n') +
                            T(`Two-factor authentication (2FA) adds an extra level of security to your account which prevents another person logging in even if they have your password.
This works by setting up an authenticator app on your phone or computer. The app then provides a 6 digit verification code each time you log in.\n\n`) +
                            T('How do I set this up?\n') +
                            T(`1. If you don't already have it, download and install the authenticator app using the link provided.
2. Open the authenticator app and either scan the QR code with your device camera or copy/paste the text code into the app. (Refer to your app's help docs if needed)
3. The authenticator app will generate a 6 digit code.
4. On our Login Verification page, enter those digits into the verification code box.
5. Click 'Sign In'`) +
                            T(`On each subsequent sign in you'll need to enter a new verification code from your authenticator app.`);
                        alert(msg);
                    });
                    $(document).on('keypress', function (e) {
                        if (e.which !== 13)
                            return;
                        $('.btn-signin-twoFactorAuth').click();
                    });
                }
                function clearVerifyInputs() {
                    $('.two-factor-auth-verify-code-input').val('');
                    $('#twoFactorAuthVerifyCodeInput1').focus();
                }
            })(logOn = account.logOn || (account.logOn = {}));
        })(account = views.account || (views.account = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
